import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class UserListDataService extends DataService<typeof Model.Core.Logic.ViewModels.Security.UserSummary, Model.Core.Logic.ViewModels.Security.UserSummary, UserSummary> {
	protected map(entity: Model.Core.Logic.ViewModels.Security.UserSummary): UserSummary {
		return new UserSummaryModel(entity);
	}

	static make(context?: any): UserListDataService {
		return new UserListDataService(context, ctx => ctx.UsersSummaries);
	}
}

export class UserSummaryModel extends EntityModel<Model.Core.Logic.ViewModels.Security.UserSummary, UserSummary> implements UserSummary {
	@property<UserSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<UserSummaryModel>(o => o.entity.userName, (o, value) => o.entity.userName = value)
	public userName: string;

	@property<UserSummaryModel>(o => o.entity.notificationEmail, (o, value) => o.entity.notificationEmail = value)
	public notificationEmail: string;

	@property<UserSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<UserSummaryModel>(o => o.entity.createdOn, (o, value) => o.entity.createdOn = value)
	public createdOn: Date;

	@property<UserSummaryModel>(o => o.entity.roles, (o, value) => o.entity.roles = value)
	public roles: string;

	@property<UserSummaryModel>(o => o.entity.isRole, (o, value) => o.entity.isRole = value)
	public isRole: boolean;
}



// WEBPACK FOOTER //
// ./src/app/general/users/list/user-list.data.ts